import React, { useState, useEffect } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import Button from 'olive-react-myoneui/lib/Button';
import Card from 'olive-react-myoneui/lib/Card';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Form from 'olive-react-myoneui/lib/Form';
import { selfCancellationEvent, confirmCancellationEvent } from '../../../../api/afterLogin/events';
import ModalCommon from '../ModalCommon';
import { SelfCancellationEvent } from '../../Loader';

import { refundIcon, calendarIcon101, documentIcon, closeCircleIcon, checkCircleComplete } from '../../../constants/icons';

const MyOrders = ({className}) => {
    const { hashId } = useParams();
    const userData   = useSelector((state) => state.user.user.logged_in_user.user);
    const paths      = useSelector((state) => state.user.paths);
    const configData = useSelector((state) => state.config);
    const navigate   = useNavigate();

    const [notFound, setNotFound]         = useState(false);
    const [eventDetails, setEventDetails] = useState([]);
    const [isLoading, setIsLoading]       = useState(true);
    const [showModal, setShowModal]       = useState(false);
    const [isTncChecked, setIsTncChecked] = useState(false);
    const [isCancellationAvailable, setIsCancellationAvailable] = useState(false);
    const [selfCancellationProcess, setSelfCancellationProcess] = useState(false);

    const orderData = [
        {
          orderInfo: {
            id: `#${eventDetails?.order_id}`,
            placedOn: eventDetails?.pay_detail_date,
            paymentMethod: eventDetails?.payment_method,
            invoice: eventDetails?.invoice_link,
          },
          orderItems: [
            {
              id: eventDetails?.event_id,
              title: eventDetails?.bce_name,
              image: eventDetails?.image && eventDetails?.image !== '' ? paths.event_path + eventDetails?.image : paths.default_event,
              price: eventDetails?.currency_symbol + eventDetails?.credit_amt,
              date: eventDetails?.event_datetime,
              cancellationDeadline: eventDetails?.cancel_enabled > 0 ? eventDetails?.cancellation_date : '',
              refundDeadline: eventDetails?.refund_enabled > 0 ? eventDetails?.refund_date : '',
              cancellationAvailable: isCancellationAvailable,
            }
          ],
        }
    ];
    const subscriptionId = eventDetails?.subscription_id ?? 0;
    const eventId        = eventDetails?.event_id ?? 0;
        
    const getEvents = async (eventId) => {
        try {
            const postParams = {
                eventId: eventId,
                userId: userData.id,
                email: userData.us_email,
            }
            const fetchEvent = await selfCancellationEvent(configData?.access_token, postParams);
            if (fetchEvent) {
                setEventDetails(fetchEvent?.data);
                setIsCancellationAvailable(fetchEvent?.data?.cancellation_available);
                setNotFound(false);
            }
            if (!fetchEvent) {
                setNotFound(true);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            setNotFound(true);
            console.error(error);
        }
    };

    const handleTncChange = (event) => {
        setIsTncChecked(event.target.checked);
    };

    const handleCancel = async () => {
        const postParams = {
            userId:  userData.id,
            email: userData.us_email,
            name: userData.us_name,
            phone: userData.us_phone,
            role: userData.us_role_id,
            subscriptionId : subscriptionId,
            eventId : eventId
        }
        const response = await confirmCancellationEvent(configData?.access_token, postParams);
        if (response) {
            setSelfCancellationProcess(true);
        }

        setShowModal(false);
    }

    const handleBack = () => {
        navigate('/student-dashboard');
    };

    const handleModalClose = () => setShowModal(false);
    
    useEffect(() => {
        if (hashId && hashId?.length % 4 === 0) {
            const convertedHashId = atob(hashId) ?? 0;
            if (convertedHashId) {
                getEvents(atob(hashId));
                return;
            }
        }
        setIsLoading(false);
        setNotFound(true);
    }, [hashId])
    
    if (selfCancellationProcess) {
        return (
            <Card className="myk__stu-transfer-processing border-0">
                <Card.Body>
                    <div className="myk__stu-line-loading-content myk__stu-transfer-success">
                        <div className="icon">{checkCircleComplete}</div>
                        <h3 style={{fontStyle: 'normal'}}>Self Cancellation Done</h3>
                        <p>You have successfully cancelled the Event subscription.</p>
                        <Button 
                            variant="primary" 
                            className="my-3 px-5 d-inline-flex align-items-center gap-2" 
                            onClick={handleBack}
                            >
                            <span>Go to Dashboard</span>
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        )
    }

    if (!selfCancellationProcess) {
        return (
            <>
            <div className={`${className || '' } myk__stu-transfer-orders-container py-5`}>
                {isLoading === false && notFound === false ? (
                <Card className="myk__stu-transfer-orders border-0">
                    <Card.Header>
                        <div className="myk_stu-page-header mb-0">
                            <h2>My Orders</h2>
                        </div>
                    </Card.Header>
                    <Card.Body>
                    <div>
                        {orderData.map((orderGroup, groupIndex) => (
                            <div key={groupIndex} className="myk__order-group">
                            {/* Order Information */}
                            <div className="myk__stu-order-info">
                                <Row className="align-items-start">
                                    <Col sm={12} lg={8} xl={8} className="myk__stu-order-details">
                                        <h3>
                                        Order Id: <span>{orderGroup?.orderInfo?.id ?? 'N/A'}</span>
                                        </h3>
                                        <p>
                                        Order placed on: <span>{orderGroup?.orderInfo?.placedOn ?? 'N/A'}</span>
                                        </p>
                                        <p>
                                        Paid by: <span>{orderGroup?.orderInfo?.paymentMethod ?? 'N/A'}</span>
                                        </p>
                                    </Col>
                                    <Col sm={12} lg={4} xl={4} className="myk__stu-order-download text-lg-end mb-3 mb-lg-0">
                                        <a href={orderGroup?.orderInfo?.invoice} rel="noopener noreferrer" download>
                                            <Button variant="outline" className="border border-primary text-primary mt-0">
                                            {documentIcon} Download Invoice
                                            </Button>
                                        </a>
                                    </Col>
                                </Row>
                            </div>
        
                            {/* Order Items */}
                            {orderGroup.orderItems.map((item) => (
                                <div className="myk__stu-order-item" key={item.id}>
                                <Row className="align-items-start">
                                    <Col sm={5} lg={5} xl={3} className="mb-3 mb-xl-0">
                                        <Card.Img
                                            src={item.image}
                                            className="rounded w-100 course-image"
                                            alt="Course Image"
                                        />
                                    </Col>
                                    <Col sm={7} lg={7} xl={9} className="card-info">
                                        <h3>
                                            <span className="myk__stu-order-title">{item?.title ?? 'No Title'}</span>
                                            <span className="myk__stu-order-price">{item?.price ?? 'N/A'}</span>
                                        </h3>
                                        <p>
                                            {calendarIcon101} <span>{item?.date ?? 'No date available'}</span>
                                        </p>
                                        {item.cancellationDeadline &&
                                        <p>
                                            {closeCircleIcon}{" "}
                                            <span>Cancellation available: Until {item?.cancellationDeadline}</span>
                                        </p>
                                        }
                                        {item.refundDeadline &&
                                        <p>
                                            {refundIcon}{" "}
                                            <span>Refund available: Until {item?.refundDeadline}</span>
                                        </p>
                                        }
                                        {!item.cancellationAvailable &&
                                        <Button
                                            variant="orange"
                                            className="bg-orange-fade mt-2 me-2"
                                            disabled="disabled"
                                        >
                                            Cancellation Unavailable
                                        </Button>
                                        }
                                    </Col>
                                </Row>
                                </div>
                            ))}
                            </div>
                        ))}
                        </div>
                    </Card.Body>
                    <Card.Footer className="d-block w-100">
                        {isCancellationAvailable === true && (
                        <Row className="mt-4">
                            <Col sm={8} lg={7} xl={9} className="myk__stu-event-tnc">
                                <Form.Check>
                                    <Form.Check.Input type="checkbox" id="tnc_transfer" onChange={handleTncChange}/>
                                    <Form.Check.Label for="tnc_transfer">
                                        Click here to agree the <a href={`${window.location.origin}/terms-and-conditions`} target="_blank"><strong>Terms and Conditions</strong></a> and proceed with cancellation. 
                                    </Form.Check.Label>
                                </Form.Check>
                            </Col>
                            <Col sm={4} lg={5} xl={3} className="myk__stu-event-tnc text-end mt-3 mt-xl-0">
                                <Button variant="primary" className="d-inline-flex align-items gap-1" disabled={!isTncChecked} onClick={setShowModal}>Self Cancellation </Button>
                            </Col>
                        </Row>
                        )}
                        {isCancellationAvailable === false  && (
                        <Row className="mt-4">
                            <Col sm={4} lg={5} xl={3} className="myk__stu-event-tnc text-end mt-3 mt-xl-0">
                                <Button variant="primary" className="d-inline-flex align-items gap-1" onClick={handleBack}>Back To Dashboard</Button>
                            </Col>
                        </Row>
                        )}
                    </Card.Footer>
                </Card>
                ) : (isLoading === false && notFound === true) ? (
                <Card className="myk__stu-transfer-orders border-0">
                    <Card.Header>
                        <div className="myk_stu-page-header mb-0">
                            <h2>Self Cancellation not available</h2>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <div className="myk__stu-order-item">
                            <Row className="align-items-start">
                                <Col sm={12} lg={12} xl={12} className="card-info">
                                    <h4>Oops ! Something weng wrong.</h4>
                                    <p className='text-center'>Sorry, self cancellation not available.</p>
                                </Col>
                            </Row>
                        </div>
                    </Card.Body>
                    <span className="card-divider my-1 mx-3" />
                    <Card.Footer className="d-block w-100">
                        <Row className="mt-4">
                            <Col sm={4} lg={5} xl={3} className="myk__stu-event-tnc text-end mt-3 mt-xl-0">
                                <Button variant="primary" className="d-inline-flex align-items gap-1" onClick={handleBack}>Back To Dashboard</Button>
                            </Col>
                        </Row>
                    </Card.Footer>
                </Card>
                ) : (
                <SelfCancellationEvent />
                )}
            </div>
            
            <ModalCommon
            show={showModal}
            onClose={handleModalClose}
            title="Are you sure you want to cancel this registration ?"
            className="myk__stu-question-modal"
            >
                <div className="text-start">
                <Row>
                    <Col className="myk__stu-min-content">
                        <p>Are you sure you want to cancel this registration ?.</p>
                        <p>This will cancel the order. This action cannot be undone.</p>
                    </Col>
                </Row>               
                <Row>
                    <Col className="text-end mt-3">
                        <Button variant="default" onClick={handleModalClose}>I'll change my mind</Button>
                        <Button variant="primary" onClick={handleCancel}>Confirm Cancellation</Button>
                    </Col>
                </Row>
                </div>
            </ModalCommon>
            </>  
        ) 
    }
    
}

export default MyOrders;